//const { forEach } = require("lodash");

angular.module('inspecciones', [])
    .controller('inspeccionesController', ['$scope', '$rootScope', '$routeParams', '$location',,
        function ($scope, $rootScope) {

            $scope.categoria = $rootScope.categoria;
    }]);

